export enum CanvasAction {
	Line,
	Text
}
